<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-Modify",
        "hide-footer": "",
        centered: "",
        size: "sm",
      },
      on: {
        hidden: function ($event) {
          return _vm.onModalHidden(false)
        },
      },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c("h3", { staticClass: "mb-1 text-center head-top-25" }, [
        _vm._v(" " + _vm._s(_vm.$t("security.Verification")) + " "),
      ]),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              {},
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("security.Verification-Code"),
                      "label-for": "login-email",
                    },
                  },
                  [
                    _c("b-form-input", {
                      attrs: {
                        placeholder:
                          _vm.ConfirmPlaceholder ||
                          _vm.$t("security.Enter-code"),
                        maxlength: "6",
                      },
                      on: { keypress: _vm.validateKeyPress },
                      model: {
                        value: _vm.code,
                        callback: function ($$v) {
                          _vm.code = $$v
                        },
                        expression: "code",
                      },
                    }),
                    !!_vm.ConfirmResendText
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-end mt-4px" },
                          [
                            _c(
                              "b-link",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.resendOtp()
                                  },
                                },
                              },
                              [
                                _c("small", [
                                  _vm._v(_vm._s(_vm.ConfirmResendText)),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("Errors", { attrs: { error: _vm.error } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "submit-button controls" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "primary",
                      disabled: !_vm.code || _vm.code.length !== 6,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.submitVerification(_vm.code)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("security.Submit")) + " ")]
                ),
              ],
              1
            ),
            !!_vm.accessToken
              ? _c(
                  "p",
                  { staticClass: "text-center mt-1 centerText" },
                  [
                    _c(
                      "b-link",
                      { on: { click: _vm.recover2FA } },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "ChevronLeftIcon" },
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("security.Recover2FA"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/SecurityVerification.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import libs_api_api from '@/libs/api/api';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





export default ({
  render,
  staticRenderFns,
  name: "SecurityVerification",
  props: {
    showVerificationPop: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    onModalHidden: {
      type: Function,
      isRequired: true,
      default: () => {}
    },
    submitVerification: {
      type: Function,
      isRequired: true,
      default: () => {}
    },
    accessToken: {
      type: String,
      isRequired: false,
      default: ""
    },
    ConfirmResendText: {
      type: String,
      isRequired: false,
      default: ""
    },
    ConfirmPlaceholder: {
      type: String,
      isRequired: false,
      default: ""
    },
    resendData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"],
    BFormFile: bootstrapvue["BFormFile"],
    BImg: bootstrapvue["BImg"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BFormInput: bootstrapvue["BFormInput"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BLink: bootstrapvue["BLink"],
    Errors: layouts_components_Errors_vue
  },
  data() {
    return {
      modalVisible: this.showVerificationPop,
      error: null,
      code: "",
      lang: this.$route.params.lang
    };
  },
  mounted() {},
  watch: {
    showVerificationPop(newValue) {
      this.modalVisible = newValue;
    }
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
      this.onModalHidden(false);
      this.code = "";
    },
    async recover2FA() {
      try {
        if (this.accessToken) {
          const res = await new libs_api_api().api({
            method: "post",
            url: "auth/recover2FAInit"
          }, {}, {
            isLoading: true,
            http_headers: {
              authorization: `Bearer ${this.accessToken}`
            }
          });
          if (res && res.message) {
            this.$router.push({
              name: "2fa-verify-email",
              params: {
                lang: this.lang || undefined
              }
            });
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.message,
                icon: "EditIcon",
                variant: "success"
              }
            });
            this.closeModal();
          } else if (res && res.error && res.error.message) {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async resendOtp() {
      if (this.resendData && this.resendData.coin) {
        try {
          const res = await new libs_api_api().api({
            method: "post",
            url: "auth/sendOTP"
          }, {
            type: "WITHDRAW",
            coin: this.resendData.coin,
            amount: this.resendData.quantity,
            address: this.resendData.toAddress
          }, {
            isLoading: true
          });
          if (res && res.result && res.result.requestStatus == "SUCCESS") {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: this.$t("security.VerificationCodeSendSuccessfully"),
                icon: "EditIcon",
                variant: "success"
              }
            });
          } else if (res && res.error && res.error.message) {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        } catch (error) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: error,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      }
    },
    validateKeyPress(event) {
      const key = event.key;
      if (key === "Enter" && event && event.target.value && event.target.value.length && event.target.value.length === 6) {
        this.submitVerification(event.target.value);
      } else if (!/^\d$/.test(key) && key !== "Backspace") {
        event.preventDefault();
        this.error = this.$t("security.enter-number");
      } else {
        this.error = "";
      }
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/SecurityVerification.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.camera {
  width: 100%;
  height: 100%;
}
.centerText a {
  display: flex;
  align-items: center;
  justify-content: center;
}
[dir] .mt-4px {
  margin-top: 4px;
}
</style>
